import { gql } from "@apollo/client"

const READ_PATIENT_IMG = gql`
  mutation readPatientImg($id: uuid!) {
    update_patients_by_pk(pk_columns: {id: $id}, _set: {ifLastImage: false}) {
      ifLastImage
    }
  }
`;

export default READ_PATIENT_IMG;
